<template>
  <div class="common-cont">
    <div class="my-queue-blk" v-if="Number(isDriver) == 1">
      <!-- <div class="my-queue-blk"> -->
      <div class="my-queue-blk-title">我的排队：</div>
      <div class="my-queue-blk-text">
        <div v-if="reportObj.report">
          车牌号：<span style="padding-left: 15px;"
            >{{ reportObj.report.license_plate }}
          </span>
        </div>
        <div v-if="lineList[active].queue_state == 1 || otherCarSate">
          排队号码：{{ lineList[active].code }}
          <!-- 排队号码：{{ indexText(queueNumber)  }} -->
        </div>
        <div
          v-if="
            lineList[active].queue_state == 2 &&
              timeCaclNum(lineList[active].call_number_time) > 5
          "
        >
          已超时：
          <span class="my-queue-blk-span">
            {{ timeCaclNum(lineList[active].call_number_time) }}
          </span>
          分钟
        </div>
      </div>
      <div class="my-queue-blk-text" v-if="lineList[active].queue_state == 1">
        <div>
          当前排位：第
          <span class="my-queue-blk-span">
            <!-- {{ queue.recentQueue }} -->
            {{ queueRecentQueueText }}
          </span>
          位
        </div>
        <div>
          前面还有：
          <span class="my-queue-blk-span">
            <!-- {{ queue.beforeQueue }}  -->
            {{ queueBeforeQueueText }}
          </span>
          位
        </div>
      </div>
      <div class="my-queue-blk-text" v-if="lineList[active].queue_state == 2">
        <div v-if="!type">
          请立即前往：
          <span class="my-queue-blk-span" style="font-size: 15px;">
            【{{ lineList[active].store_name
            }}{{ lineList[active].warehouse_name }}】
          </span>
        </div>
      </div>
      <div class="my-queue-blk-text" v-if="otherCarSate">
        <div>
          当前状态：<span style="color:#ec3f67">{{ otherCarSateText }}</span>
        </div>
      </div>
    </div>
    <div class="recent-queue">
      <div class="recent-queue-title">
        请以下车辆立即前往{{ typeTextFormat(type) }}区：
      </div>
      <div
        class="recent-queue-left"
        v-for="(item, index) in firstList"
        :key="index"
      >
        <div class="recent-queue-left-blk" v-if="item.report_info">
          <div class="top">{{ item.code }}</div>
          <!-- 平板车 -->
          <img
            src="../../assets/img/flat.png"
            alt=""
            width="70px"
            v-if="item.report_info.vehicle_type === 1"
          />
          <!-- 货柜车 -->
          <img
            src="../../assets/img/truck.png"
            alt=""
            width="70px"
            v-else-if="item.report_info.vehicle_type === 2"
          />
          <!-- 高栏车 -->
          <img
            src="../../assets/img/gaolan.png"
            alt=""
            width="70px"
            v-else-if="item.report_info.vehicle_type === 5"
          />
          <img
            src="../../assets/img/else_icon.png"
            alt=""
            width="70px"
            v-else
          />
        </div>
        <div class="recent-queue-right" v-if="item.report_info">
          <span style="font-size: 18px;">{{
            item.report_info.license_plate
          }}</span>
          <span style="font-size: 14px;color: #4F4A4C;float: right;">
            车型：
            {{
              item.report_info.vehicle_type === 0
                ? "--"
                : vehicleType(item.report_info.vehicle_type)
            }} </span
          ><br />
          <span
            ><span style="color: #4F4A4C">{{type ? "卸货位置：" : "装货位置："}}</span>
            <span style="color: #008B5E;" v-if="item.warehouse">
              {{ item.warehouse.store_name }}{{ item.warehouse.warehouse_name }}
            </span></span
          >
          <template v-if="!type && Number(isDriver) != 1">
            <br />
            <span style="color: #4F4A4C">已叫号：{{ timeCacl(item.call_number_time)}}</span>
          </template>
        </div>
      </div>
      <Empty v-if="firstList.length == 0"></Empty>
    </div>
    <div class="recent-queue">
      <div class="recent-queue-title">正在排队中：</div>
      <div
        class="recent-queue-left"
        v-for="(item, index) in secondList"
        :key="index"
      >
        <div class="recent-queue-left-blk">
          <div class="top">{{ item.code }}</div>
          <div class="image">
            <!-- 平板车 -->
            <img
              src="../../assets/img/flat.png"
              alt=""
              width="70px"
              v-if="item.report_info.vehicle_type === 1"
            />
            <!-- 货柜车 -->
            <img
              src="../../assets/img/truck.png"
              alt=""
              width="70px"
              v-else-if="item.report_info.vehicle_type === 2"
            />
            <!-- 高栏车 -->
            <img
              src="../../assets/img/gaolan.png"
              alt=""
              width="70px"
              v-else-if="item.report_info.vehicle_type === 5"
            />
            <img
              src="../../assets/img/else_icon.png"
              alt=""
              width="70px"
              v-else
            />
          </div>
        </div>
        <div class="recent-queue-right1" v-if="item.report_info">
          <span style="font-size: 15px;">
            {{ item.report_info.license_plate }}
          </span>
          <span style="color: #4F4A4C;float: right;"
            >车型：
            {{
              item.report_info.vehicle_type === 0
                ? "--"
                : vehicleType(item.report_info.vehicle_type)
            }} </span
          ><br />
          <span>单据编号：</span><span style="color: red;word-break: break-all;">{{ item.order_code || '--' }}</span><br/>
          <span>进厂时间：</span>
          <span v-if="item.into_factory_time > 0">{{
            formatTime(item.into_factory_time)
          }}</span>
          <span v-else>--</span><br />
          <div style="display: inline-block;margin-right: 20px;">
            状态：
            <span v-if="item.into_factory_time == 0">--</span>
            <span v-else-if="item.into_factory_time > 0">
              <span
                v-if="
                  formatStatus(item.into_factory_time, item.booking_time) == 0
                "
                style="color: #00CBD2;"
              >
                提前到厂
              </span>
              <span
                v-if="
                  formatStatus(item.into_factory_time, item.booking_time) == 1
                "
                style="color: #008B5E;"
              >
                准时到厂
              </span>
              <span
                v-if="
                  formatStatus(item.into_factory_time, item.booking_time) == 2
                "
                style="color: #EC3F67;"
              >
                迟到到厂
              </span>
            </span>
            <br/>
            <span><waitAndReportShow :item="item"></waitAndReportShow></span>
          </div>
          <!-- <span>已等待：{{ timeCacl(item.create_time) }}</span> -->
        </div>
      </div>
      <Empty v-if="secondList.length == 0"></Empty>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Empty from "@/components/tips/Empty.vue";
import waitAndReportShow from "@/views/rhwx/commonComponent/waitAndReportShow.vue";
import socketListComputedMixin from "@/mixins/rh/socketListComputedMixin.js";
import { getVehicleTypeLabel } from "@/assets/js/vehicleTypeEnum";
export default {
  props: [
    "reportObj",
    "listObj",
    "queueNumber",
    "firstList",
    "secondList",
    "socketOperaObj",
    "isDriver",
    "lineList",
    "active",
    "businessType"
  ],
  data() {
    return {
      vehicleType: getVehicleTypeLabel,
      // firstList: [], // 装货区列表
      // secondList: [], // 正在排队中列表
      colorTag: 0,
      queue: {
        status: 0, // 当前状态 0 排队中  1 已叫号
        recentQueue: 0, // 当前排位
        beforeQueue: 0, // 前面还有*位
        overTime: 0, // 已超时
        store: "", // 库位
        wareHouse: "" // 仓位,
      },
      calculationTime: null,
      calculationTimeInterval: null
    };
  },
  components: {
    Empty,
    waitAndReportShow
  },
  mixins: [socketListComputedMixin],
  async mounted() {
    this.queue.recentQueue = this.firstList.length + 1;
    this.queue.beforeQueue = this.firstList.length;
  },
  methods: {},

  created() {
    this.calculationTime = moment();
    this.calculationTimeInterval = window.setInterval(() => {
      this.calculationTime = moment();
    }, 60000);
  },

  computed: {
    queueBeforeQueueText() {
      let val = "";
      for (let i = 0; i < this.secondList.length; i++) {
        if (this.reportObj.report.id === this.secondList[i].report_id) {
          val = i;
        }
      }
      return val;
    },
    queueRecentQueueText() {
      let val = "";
      for (let i = 0; i < this.secondList.length; i++) {
        if (this.reportObj.report.id === this.secondList[i].report_id) {
          val = i + 1;
        }
      }
      return val;
    },
    otherCarSate() {
      // "queue_state":"",        //排队状态(1排队中；2叫号中；3已过号；4已失效 [已过号状态超过24小时未更新]；5已完成；6已终止）
      //  "loading_state":"",    // 装车状态：(0未开始；1等待装货；2拒绝装货[在厂]；3装货中；4装货完成[等单中]；5已完成[已开单]；6已终止)    }
      if (
        this.lineList[this.active].queue_state == 3 ||
        this.lineList[this.active].queue_state == 4 ||
        (this.lineList[this.active].queue_state == 5 &&
          this.lineList[this.active].loading_state == 2) ||
        (this.lineList[this.active].queue_state == 5 &&
          this.lineList[this.active].loading_state == 3) ||
        (this.lineList[this.active].queue_state == 5 &&
          this.lineList[this.active].loading_state == 1) ||
        (this.lineList[this.active].queue_state == 5 &&
          this.lineList[this.active].loading_state == 4) ||
        (this.lineList[this.active].queue_state == 5 &&
          this.lineList[this.active].loading_state == 5) ||
        this.lineList[this.active].queue_state == 6 ||
        this.lineList[this.active].loading_state == 6
      ) {
        return true;
      } else {
        return false;
      }
    },
    otherCarSateText() {
      if (this.lineList[this.active].queue_state == 3) {
        return "已过号";
      }
      if (this.lineList[this.active].queue_state == 4) {
        return "已失效";
      }
      if (
        this.lineList[this.active].queue_state == 5 &&
        this.lineList[this.active].loading_state == 2
      ) {
        return "已拒绝";
      }
      if (
        this.lineList[this.active].queue_state == 5 &&
        this.lineList[this.active].loading_state == 3
      ) {
        return this.typeTextFormat(this.type) + "中";
      }
      if (
        this.lineList[this.active].queue_state == 5 &&
        this.lineList[this.active].loading_state == 1
      ) {
        return "等待" + this.typeTextFormat(this.type);
      }
      if (
        this.lineList[this.active].queue_state == 5 &&
        this.lineList[this.active].loading_state == 4
      ) {
        return "等单中";
      }
      if (
        this.lineList[this.active].queue_state == 5 &&
        this.lineList[this.active].loading_state == 5
      ) {
        return "已完成";
      }
      if (
        this.lineList[this.active].queue_state == 6 ||
        this.lineList[this.active].loading_state == 6
      ) {
        return "已终止";
      }

      return "";
    },
    type() {
      let type = false;
      if (this.businessType == 2 || this.businessType == 3) {
        type = true;
      } else {
        type = false;
      }
      return type;
    }
  },

  watch: {
    // listObj() {
    //   this.firstList = [];
    //   this.secondList = [];
    //   this.listObj.queue.forEach(item => {
    //     // 2叫号中
    //     if (Number(item.queue_state) === 2) {
    //       this.firstList.push(item);
    //     }
    //     // 排队中
    //     if (Number(item.queue_state) === 1) {
    //       this.secondList.push(item);
    //     }
    //   });
    // }
    socketOperaObj(val) {
      console.log(val);
    },
    firstList(val) {
      console.log("anka firstList叫号中", val);
      for (let i = 0; i < val.length; i++) {
        if (this.reportObj.report.id === val[i].report_id) {
          this.queue.recentQueue = i + 1;
          this.queue.beforeQueue = i;
        }
      }
    },
    secondList(val) {
      console.log("anka secondList排队中", val);
      for (let i = 0; i < val.length; i++) {
        if (this.reportObj.report.id === val[i].report_id) {
          this.queue.recentQueue = this.firstList.length + i + 1;
          this.queue.beforeQueue = this.firstList.length + i;
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.common-cont {
  // min-height: calc(100vh - 2px);
  background: #f4f5f6;
  border-bottom: 1px solid #f4f5f6;
  // 我的排队
  .my-queue-blk {
    background: #fff;
    background: #eefcf9;
    padding: 16px 16px;
    font-size: 16px;
    &-title {
      font-size: 18px;
      padding: 0px 0px 6px;
    }
    &-text {
      display: flex;
      line-height: 30px;
      align-items: baseline;
      & > div {
        flex: 1;
      }
    }
    &-span {
      font-size: 24px;
      color: #ec3f67;
      padding: 0px 2px;
    }
  }
  .recent-queue {
    background: #fff;
    padding: 16px;
    margin-bottom: 10px;
    &-title {
      font-size: 18px;
      padding-bottom: 18px;
    }
    &-left {
      background: #f9f9fa;
      margin-bottom: 10px;
      display: flex;
      &-blk {
        display: inline-block;
        margin-right: 10px;
        width: 108px;
        vertical-align: top;
        position: relative;
        .top {
          background: #00c8d2;
          box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
          border-radius: 4px 0 13px 0;
          text-align: center;
          color: white;
          line-height: 23px;
          margin-bottom: 10px;
          font-size: 18px;
          min-width: 35px;
          display: inline-block;
          padding: 2px 11px;
        }
        .image {
          top: 50%;
          left: 50%;
          position: absolute;
          transform: translate(-50%, -28%);
        }
      }
    }
    &-right {
      display: inline-block;
      width: calc(88vw - 120px);
      margin: 16px 0px;
      line-height: 30px;
      font-size: 16px;
    }
    &-right1 {
      display: inline-block;
      width: calc(88vw - 120px);
      margin: 16px 0px;
      line-height: 22px;
      font-size: 16px;
    }
  }
}
</style>
